/**
 * Rillion Prime API v1.0
 * A REST API endpoint for System operations.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BaseModel } from './baseModel';
import { HeadersOnly } from './headersOnly';
import { RowStates } from './rowStates';

export interface LicenceModel {
  headersOnly?: HeadersOnly;
  forProcessing?: boolean | null;
  index?: number | null;
  inspected?: boolean | null;
  locked?: boolean | null;
  lockedRowID?: number | null;
  lockedRowLockedTime?: string | null;
  lockedRowLoginName?: string | null;
  lockedRowRole?: string | null;
  lockID?: number | null;
  lockType?: number | null;
  parent?: BaseModel;
  rowState?: RowStates;
  selected?: boolean | null;
  keyValuesRowState?: RowStates;
  licenceID?: number | null;
  licence?: string | null;
  haveArena?: boolean | null;
  haveBuyer?: boolean | null;
  haveContract?: boolean | null;
  haveDocument?: boolean | null;
  haveEInvoiceCapture?: boolean | null;
  haveEmailApproval?: boolean | null;
  haveExpenditure?: boolean | null;
  haveExpense?: boolean | null;
  haveFileIntegration?: boolean | null;
  haveIntegrationAd?: boolean | null;
  haveInvoice?: boolean | null;
  haveInvoiceCapture?: boolean | null;
  havePaletteMobile?: boolean | null;
  havePurchaseOrder?: boolean | null;
  haveWarninglistedSuppliers?: boolean | null;
  isValid?: boolean | null;
  isActive?: boolean | null;
  type?: number | null;
  nextReportingTime?: string | null;
  dateCreated?: string | null;
  isValid_IgnoreValidTo_Ignore45Overdue?: boolean | null;
  licencee?: string | null;
  licenceFile?: string | null;
  licenceKey?: string | null;
  licenceNo?: string | null;
  maxNumberOfContracts?: number | null;
  maxNumberOfDocument?: number | null;
  maxNumberOfExpenditures?: number | null;
  maxNumberOfExpense?: number | null;
  maxNumberOfInvoices?: number | null;
  maxNumberOfPurchaseRequisitions?: number | null;
  maxNumberOfUsers?: number | null;
  messageToCustomer?: string | null;
}
